import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/login'
// import Dashboard from '@/pages/dashboard'
import Dashboard from '@/pages/dashboard'
import Enquiry from '@/pages/enquiry'
import Task from '@/pages/task'
import TaskTemplate from '@/pages/taskTemplate'
import Requisition from '@/pages/requisition'
import Map from '@/pages/map'
import { store } from './../store/store'

Vue.use(Router)
let requestedPage = null

async function securityGuard (to, from, next) {
    let tokenId = to.query.tokenid || undefined
    let tokenValue = to.query.tokenvalue || undefined

    if (to.name !== 'login' && from.name === null) {
        try {
            const authenticated = await store.dispatch('ping', {tokenId: tokenId, tokenValue: tokenValue})
            if (authenticated) {
                if (store.getters.userInfo.userId === null) {
                    await store.dispatch('getCurrentUserInfo')
                    next()
                } else {
                    next()
                }
            } else {
                requestedPage = {name: to.name, params: to.params, done: false}
                next({name: 'login'})
            }
        } catch (error) {
            console.error('Security guard', error)
        }
    } else if (requestedPage != null && !requestedPage.done) {
        requestedPage.done = true
        next(requestedPage)
    } else {
        next()
    }
}

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login
        },
        {
            path: '/forside',
            name: 'dashboard',
            component: Dashboard,
            beforeEnter: securityGuard
        },
        {
            path: '/henvendelse',
            name: 'enquiry',
            component: Enquiry,
            beforeEnter: securityGuard
        },
        {
            path: '/henvendelse/:id',
            name: 'enquiryid',
            component: Enquiry,
            params: {
                id: ''
            },
            beforeEnter: securityGuard
        },
        {
            path: '/opgave',
            name: 'task',
            component: Task,
            beforeEnter: securityGuard
        },
        {
            path: '/opgave/:id',
            name: 'taskid',
            component: Task,
            params: {
                id: ''
            },
            beforeEnter: securityGuard
        },
        {
            path: '/entreprenoeropgave/:id',
            name: 'requisitionid',
            component: Requisition,
            params: {
                id: ''
            },
            beforeEnter: securityGuard
        },
        {
            path: '/skabelon',
            name: 'tasktemplate',
            component: TaskTemplate,
            beforeEnter: securityGuard
        },
        {
            path: '/skabelon/:id',
            name: 'tasktemplateid',
            component: TaskTemplate,
            params: {
                id: ''
            },
            beforeEnter: securityGuard
        },
        {
            path: '/kort',
            name: 'map',
            component: Map,
            beforeEnter: securityGuard
        },
        {
            path: '*',
            redirect: '/',
            beforeEnter: securityGuard
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js